<style>
  .ex-icon {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
</style>

<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" class="ex-icon">
  <path d="M.3 17l6.45-8.62L.53.08h3.58l4.4 6.07L12.88.08h3.6l-6.21 8.3L16.7 17h-3.6l-4.6-6.34L3.9 17H.3z" fill="#000"/>
</svg>